import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface F919 {
  f919_01: string;        // 刷卡卡號 (PK, 10 chars)
  f919_11: string;        // 員工編號 (8 chars, required)
  f919_12: string | null; // 領用日期
  f919_13: string | null; // 還卡日期
  f919_14: string;        // 歸屬部門 (4 chars, required)
  f919_15: string;        // 備註 (memo)
  f919_91: string;        // 建立者
  f919_92: string | null; // 建立日期
  f919_93: string;        // 修改者
}

// ============================================================
// Request / Response types
// ============================================================

export interface PW9119ListResponse {
  data: F919[];
  total: number;
  page: number;
  size: number;
}

export interface PW9119CreateRequest {
  master: Partial<F919>;
}

// ============================================================
// API methods
// ============================================================

export const pw9119Api = {
  async list(page = 1, size = 20): Promise<PW9119ListResponse> {
    const res = await apiClient.get('/api/pw9119', { params: { page, size } });
    return res.data;
  },

  async search(keyword: string): Promise<PW9119ListResponse> {
    const res = await apiClient.get('/api/pw9119/search', { params: { keyword } });
    return res.data;
  },

  /** Single PK: card number (f919_01) */
  async get(cardNo: string): Promise<F919> {
    const res = await apiClient.get(`/api/pw9119/${encodeURIComponent(cardNo)}`);
    return res.data;
  },

  async create(data: PW9119CreateRequest): Promise<F919> {
    const res = await apiClient.post('/api/pw9119', data);
    return res.data;
  },

  /** Single PK: card number (f919_01) */
  async update(cardNo: string, data: PW9119CreateRequest): Promise<F919> {
    const res = await apiClient.put(`/api/pw9119/${encodeURIComponent(cardNo)}`, data);
    return res.data;
  },

  /** Single PK: card number (f919_01) */
  async delete(cardNo: string): Promise<void> {
    await apiClient.delete(`/api/pw9119/${encodeURIComponent(cardNo)}`);
  },

  /** Lookup: employee, department */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(`/api/pw9119/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
